/** @prettier */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import styles from './StyledEasySpan.module.scss';

const StyledEasySpan = ({ short, registered, size = 'inherit' }) => (
  <Fragment>
    <span className={styles.cooper} style={{ fontSize: `${size}px`, lineHeight: `${size}px` }}>
      easy{short ? null : 'Bet'}
    </span>
    {registered ? (
      <span
        style={{
          fontSize: `${Math.ceil((size * 2) / 3)}px`,
          lineHeight: `${Math.ceil((size * 2) / 3)}px`,
        }}
      >
        ®
      </span>
    ) : null}
  </Fragment>
);

StyledEasySpan.propTypes = {
  short: PropTypes.bool,
  registered: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default StyledEasySpan;
